"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgWavesOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.waves_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "waves_outline_svg__transparent_box" },
            React.createElement("path", { className: "waves_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "waves_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "waves_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M8 10a6.47 6.47 0 004-1.45A6.44 6.44 0 0016 10a6.47 6.47 0 004-1.45A6.44 6.44 0 0024 10a6.5 6.5 0 004.77-2.19l.62-.81-1.53-1.22-.64.76A4.47 4.47 0 0124 8a4.69 4.69 0 01-3.24-1.47l-.76-.9-.76.91A4.47 4.47 0 0116 8a4.69 4.69 0 01-3.24-1.47l-.76-.9-.76.91A4.47 4.47 0 018 8a4.65 4.65 0 01-3.25-1.47l-.64-.76-1.53 1.29.64.76A6.66 6.66 0 008 10zM27.22 14.54A4.47 4.47 0 0124 16a4.69 4.69 0 01-3.24-1.47l-.77-.9-.76.91A4.47 4.47 0 0116 16a4.69 4.69 0 01-3.24-1.47l-.77-.9-.76.91A4.47 4.47 0 018 16a4.65 4.65 0 01-3.24-1.47l-.64-.76-1.54 1.29.64.76A6.66 6.66 0 008 18a6.47 6.47 0 004-1.45 6.24 6.24 0 008 0 6.26 6.26 0 008.76-.74l.63-.77-1.53-1.26zM27.22 22.54A4.47 4.47 0 0124 24a4.69 4.69 0 01-3.24-1.47l-.77-.9-.76.91A4.47 4.47 0 0116 24a4.69 4.69 0 01-3.24-1.47l-.77-.9-.76.91A4.47 4.47 0 018 24a4.65 4.65 0 01-3.24-1.47l-.64-.76-1.54 1.29.64.76A6.66 6.66 0 008 26a6.47 6.47 0 004-1.45 6.24 6.24 0 008 0 6.26 6.26 0 008.76-.74l.63-.77-1.53-1.26z" }))));
}
exports.default = SvgWavesOutline;
//# sourceMappingURL=WavesOutline.js.map